import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieConsent from './components/feature/CookieConsent';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-cream">
            <div className="text-center">
              <div className="w-16 h-16 border-4 border-wood border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-wood font-medium">Yükleniyor...</p>
            </div>
          </div>
        }
      >
        <AppRoutes />
        <CookieConsent />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
